import { useFeature } from 'src/app/FeatureToggle/useFeature';
import { DispatchAssignmentRead } from 'src/common/external/bambi-api/bambiApi';

import { MileageBadge } from '../../DispatchCalendarHeader/DispatchCalendarHeaderMenu/MileageBadge';
import { EstimatedRevenueBadge } from '../../DispatchCalendarHeader/EstimatedRevenueBadge';

interface AssignmentHeaderBadgesProps {
  assignment: DispatchAssignmentRead;
}
export function AssignmentHeaderBadges({
  assignment,
}: AssignmentHeaderBadgesProps) {
  const { isEnabled: isItineraryEnabled, isLoading: isItineraryLoading } =
    useFeature('itinerary');

  const shouldRenderMileageBadges = !isItineraryLoading && isItineraryEnabled;

  return (
    <div className="flex flex-col gap-1">
      {assignment.show_pricing ? (
        <EstimatedRevenueBadge revenue={assignment.estimated_revenue ?? 0} />
      ) : null}
      {shouldRenderMileageBadges && (
        <>
          <MileageBadge miles={assignment.loaded_miles ?? 0} type="loaded" />
          <MileageBadge
            miles={assignment.unloaded_miles ?? 0}
            type="unloaded"
          />
        </>
      )}
    </div>
  );
}
